"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateChannel = void 0;
var tslib_1 = require("tslib");
var channel_types_1 = require("@wix/wix-vod-constants/dist/common/channel-types");
var url_types_1 = require("@wix/wix-vod-constants/dist/common/url-types");
var media_types_1 = require("@wix/wix-vod-constants/dist/common/media-types");
var youtube_1 = require("../../../public/services/youtube/youtube");
var private_catalog_service_1 = require("../../../catalog-services/private-catalog-service");
// TODO: there are 3 layers of inheritance (PrivateChannel -> PrivateCatalogService -> CatalogService). Remove.
var PrivateChannel = /** @class */ (function (_super) {
    tslib_1.__extends(PrivateChannel, _super);
    function PrivateChannel(httpClient) {
        var _this = _super.call(this, httpClient) || this;
        _this.fetchSingleChannel = function (channelId, requestConfig) {
            return _this.get("/catalog/lists/".concat(channelId), requestConfig);
        };
        _this.fetchPublicSingleChannel = function (channelId, requestConfig) {
            return _this.get("/public/lists/".concat(channelId, "/info"), requestConfig);
        };
        _this.youtubeService = new youtube_1.YoutubeService(httpClient);
        _this.defaultRequestOptions = {
            skipExternal: false,
        };
        return _this;
    }
    PrivateChannel.prototype.isYoutubeChannel = function (channel) {
        return (channel.channel_type === channel_types_1.CHANNEL_TYPES.YOUTUBE_FEED &&
            channel.url_type === url_types_1.URL_TYPES.CHANNEL);
    };
    PrivateChannel.prototype.isYoutubePlaylist = function (channel) {
        return (channel.channel_type === channel_types_1.CHANNEL_TYPES.YOUTUBE_FEED &&
            channel.url_type === url_types_1.URL_TYPES.PLAYLIST);
    };
    /**
     Fetch youtube channel by playlistId or channelId
     @param channel
     **/
    PrivateChannel.prototype.fetchExternalSingleItem = function (channel) {
        if (channel.external_id && this.isYoutubeChannel(channel)) {
            return this.youtubeService.getChannelById(channel.external_id);
        }
        if (channel.external_id && this.isYoutubePlaylist(channel)) {
            return this.youtubeService.getPlaylistById(channel.external_id);
        }
        throw new Error('Method is not allowed');
    };
    PrivateChannel.prototype.fetchExternalLists = function (channelIds, playlistIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requests;
            return tslib_1.__generator(this, function (_a) {
                requests = [
                    channelIds.length
                        ? this.youtubeService.getChannelsByIds(channelIds)
                        : null,
                    playlistIds.length
                        ? this.youtubeService.getPlayListsByIds(playlistIds)
                        : null,
                ];
                return [2 /*return*/, Promise.all(requests).then(function (_a) {
                        var channelsResponse = _a[0], playlistsResponse = _a[1];
                        return ({
                            channels: channelsResponse ? channelsResponse.data.items : [],
                            playlists: playlistsResponse ? playlistsResponse.data.items : [],
                        });
                    })];
            });
        });
    };
    PrivateChannel.prototype.fetchInfo = function (fetcher, channelId, extraOptions, requestConfig) {
        var _this = this;
        var options = tslib_1.__assign(tslib_1.__assign({}, this.defaultRequestOptions), extraOptions);
        return fetcher(channelId, requestConfig).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var channel, externalResponse, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (options.skipExternal) {
                            return [2 /*return*/, Promise.resolve(response)];
                        }
                        channel = response.data;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.fetchExternalSingleItem(channel)];
                    case 2:
                        externalResponse = _a.sent();
                        Object.assign(response.data, {
                            youtube_data: externalResponse.data,
                        });
                        return [2 /*return*/, response];
                    case 3:
                        e_1 = _a.sent();
                        // not external, or youtube pix.wix request failed
                        return [2 /*return*/, Promise.resolve(response)];
                    case 4: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * Get channels from VOD backend, without YoutubeFeed data
     * @param config
     * @param requestConfig
     */
    PrivateChannel.prototype.fetchCatalogLists = function (config, requestConfig) {
        if (config === void 0) { config = {}; }
        config.media_type = config.media_type || media_types_1.MEDIA_TYPES.SECURE_VIDEO;
        config.direction = config.direction || 'desc';
        config.order = config.order || 'date';
        config.page_size = config.page_size || 30;
        var queryParams = {
            query: config.query,
            tag: config.tag,
            category: config.category,
            cursor: config.cursor,
            media_type: config.media_type,
            page_size: config.page_size,
            order: config.direction === 'desc' ? "-".concat(config.order) : config.order,
        };
        return this.get('/catalog/lists', tslib_1.__assign({ params: queryParams }, requestConfig));
    };
    /**
     * Create channel
     * @param channel
     * @param requestConfig
     */
    PrivateChannel.prototype.create = function (channel, requestConfig) {
        return this.post('/catalog/lists', channel, requestConfig);
    };
    /**
     * Delete channel
     * @param channelId
     * @param requestConfig
     */
    PrivateChannel.prototype.delete = function (channelId, requestConfig) {
        return _super.prototype.delete.call(this, "/catalog/lists/".concat(channelId), requestConfig);
    };
    /**
     * Update channel
     * @param channelId
     * @param channel
     * @param requestConfig
     */
    PrivateChannel.prototype.update = function (channelId, channel, requestConfig) {
        return this.put("/catalog/lists/".concat(channelId), channel, requestConfig);
    };
    /**
     * Get composite information about one channel from VOD catalog and Youtube
     * @param channelId
     * @param extraOptions
     * @param requestConfig
     * @return Promise<HttpResponse<ChannelItem>>
     */
    PrivateChannel.prototype.getInfo = function (channelId, extraOptions, requestConfig) {
        var fetcher = this.fetchSingleChannel;
        return this.fetchInfo(fetcher, channelId, extraOptions, requestConfig);
    };
    /**
     * Get composite information about channels from VOD catalog and Youtube
     * @param config
     * @param requestConfig
     */
    PrivateChannel.prototype.getLists = function (config, requestConfig) {
        var _this = this;
        if (config === void 0) { config = {}; }
        var options = tslib_1.__assign(tslib_1.__assign({}, this.defaultRequestOptions), config.extraOptions);
        // fetch channels from VOD catalog
        return this.fetchCatalogLists(config.params, requestConfig).then(function (response) {
            if (options.skipExternal) {
                return response;
            }
            // find all YoutubeItems from all channels
            var youtubeChannelIds = [];
            var youtubePlaylistIds = [];
            response.data.items.forEach(function (item) {
                if (!item.external_id) {
                    return;
                }
                if (_this.isYoutubeChannel(item)) {
                    youtubeChannelIds.push(item.external_id);
                }
                else if (_this.isYoutubePlaylist(item)) {
                    youtubePlaylistIds.push(item.external_id);
                }
            });
            return _this.fetchExternalLists(youtubeChannelIds, youtubePlaylistIds).then(function (_a) {
                var channels = _a.channels, playlists = _a.playlists;
                return tslib_1.__assign(tslib_1.__assign({}, response), { data: tslib_1.__assign(tslib_1.__assign({}, response.data), { items: response.data.items.map(function (item) {
                            var youtube_data;
                            if (item.external_id) {
                                if (_this.isYoutubeChannel(item)) {
                                    youtube_data = channels.find(function (channel) { return channel.id === item.external_id; });
                                }
                                else if (_this.isYoutubePlaylist(item)) {
                                    youtube_data = playlists.find(function (playlist) { return playlist.id === item.external_id; });
                                }
                                // if youtube_data is not defined, probably it was removed from 3rd party API, return null
                                youtube_data = youtube_data || null;
                            }
                            return tslib_1.__assign(tslib_1.__assign({}, item), { youtube_data: youtube_data });
                        }) }) });
            }, function () { return response; });
        });
    };
    /**
     * Public.
     * Get composite information about one channel from VOD catalog and Youtube
     * @param channelId
     * @param extraOptions
     * @param requestConfig
     * @return Promise<HttpResponse<PublicChannelItem>>
     */
    PrivateChannel.prototype.getPublicInfo = function (channelId, extraOptions, requestConfig) {
        var fetcher = this.fetchPublicSingleChannel;
        return this.fetchInfo(fetcher, channelId, extraOptions, requestConfig);
    };
    /**
     * Public.
     * Returns a list of purchases made by currently active user
     * @param {string} channelId
     * @param {string} instance
     * @param {RequestOptions} requestConfig
     * @returns {Promise<HttpResponse<MemberInfoResponse>>}
     */
    PrivateChannel.prototype.getPublicMemberInfo = function (channelId, instance, requestConfig) {
        return this.post("/public/lists/".concat(channelId, "/member/info?instance=").concat(instance), {}, requestConfig);
    };
    PrivateChannel.prototype.getPublicVideoPreviewUrls = function (channelId, instance, requestConfig) {
        var params = { instance: instance };
        return this.get("/public/lists/play/".concat(channelId), tslib_1.__assign({ params: params }, requestConfig));
    };
    PrivateChannel.prototype.getPurchases = function (channelId, pageSize, requestConfig) {
        if (pageSize === void 0) { pageSize = 1; }
        return this.get("/catalog/lists/".concat(channelId, "/purchases?page_size=").concat(pageSize), requestConfig);
    };
    PrivateChannel.prototype.getTrailerPlayUrls = function (fileName) {
        return this.get("/catalog/videos/".concat(fileName, "/play"));
    };
    return PrivateChannel;
}(private_catalog_service_1.PrivateCatalogService));
exports.PrivateChannel = PrivateChannel;
//# sourceMappingURL=channel.js.map